// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"e441cab9aba37a48c764","532":"d5b3f2deffabb6fb689b","691":"686ced6bd4c8bca31b24"}[chunkId] + ".js";
};